import { Entity, EntityMap } from './types';

import { objectWithoutKeys } from '.';

/**
 * Adds these entities to the map of fulfilled entities, and removes them from the map of pending entities.
 */
export const moveToFulfilled: <T extends Entity>(state: EntityMap<T>, entities?: Record<string, T>) => EntityMap<T> = (
  state,
  entities = {}
) => {
  const newPending = objectWithoutKeys<boolean>(state.pending.byId, Object.keys(entities));
  const newFulfilled = { ...state.fulfilled.byId, ...entities };

  return {
    ...state,
    pending: {
      ...state.pending,
      byId: newPending,
    },
    fulfilled: {
      ...state.fulfilled,
      byId: newFulfilled,
    },
  };
};
